var _rect, _rect2, _path, _rect3, _path2, _path3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSourcesHugoDecrypte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 549.275,
    y: 504.062,
    width: 127.88,
    height: 63.9403,
    transform: "rotate(45 549.275 504.062)",
    fill: "url(#paint0_linear_102_20)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 549.275,
    y: 504.062,
    width: 127.88,
    height: 63.9403,
    transform: "rotate(45 549.275 504.062)",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M319.701 639.403C496.268 639.403 639.403 496.268 639.403 319.701C639.403 143.135 496.268 0 319.701 0C143.135 0 0 143.135 0 319.701C0 496.268 143.135 639.403 319.701 639.403ZM319.701 548.821C446.24 548.821 548.821 446.24 548.821 319.701C548.821 193.162 446.24 90.5821 319.701 90.5821C193.162 90.5821 90.5821 193.162 90.5821 319.701C90.5821 446.24 193.162 548.821 319.701 548.821Z",
    fill: "url(#paint1_linear_102_20)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 611.614,
    y: 513.654,
    width: 266.418,
    height: 138.537,
    rx: 50,
    transform: "rotate(45 611.614 513.654)",
    fill: "url(#paint2_linear_102_20)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M403.623 174.345C408.773 165.425 405.747 153.925 396.358 149.692C379.771 142.213 362.149 137.188 344.044 134.804C319.762 131.608 295.09 133.225 271.434 139.564C247.778 145.902 225.602 156.838 206.172 171.747C191.684 182.864 178.935 196.027 168.31 210.797C162.296 219.158 165.425 230.63 174.345 235.78V235.78C183.265 240.93 194.582 237.786 200.804 229.578C208.841 218.974 218.278 209.471 228.878 201.338C244.422 189.411 262.162 180.662 281.087 175.591C300.012 170.52 319.75 169.226 339.175 171.784C352.422 173.528 365.346 177.039 377.608 182.203C387.1 186.201 398.473 183.265 403.623 174.345V174.345Z",
    fill: "url(#paint3_linear_102_20)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M486.644 337.065C496.888 338.13 506.155 330.679 506.193 320.379C506.271 298.734 502.581 277.191 495.24 256.728C487.899 236.265 477.053 217.289 463.233 200.629C456.657 192.702 444.767 192.841 437.536 200.176V200.176C430.305 207.51 430.496 219.255 436.872 227.344C446.815 239.958 454.681 254.128 460.132 269.322C465.583 284.517 468.518 300.456 468.861 316.514C469.081 326.811 476.4 335.999 486.644 337.065V337.065Z",
    fill: "url(#paint4_linear_102_20)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 621.514,
    y: 560.543,
    width: 159.851,
    height: 31.9701,
    rx: 15.9851,
    transform: "rotate(45 621.514 560.543)",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_20",
    x1: 604.094,
    y1: 474.619,
    x2: 599.196,
    y2: 589.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_20",
    x1: 639.403,
    y1: 0,
    x2: 0,
    y2: 639.403,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314017,
    stopColor: "#4634E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664081,
    stopColor: "#D648AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FB4DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_20",
    x1: 744.823,
    y1: 513.654,
    x2: 744.823,
    y2: 652.191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.979167,
    stopColor: "#FB4DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_102_20",
    x1: 506,
    y1: -2.49995,
    x2: -34,
    y2: 454.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4DA0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_102_20",
    x1: 640.5,
    y1: 122.5,
    x2: 82.5,
    y2: 608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#182EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB4DA0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourcesHugoDecrypte);
export default __webpack_public_path__ + "static/media/sources_hugo_decrypte.b296ac5e05ad94bf783f004d780bdfc6.svg";
export { ForwardRef as ReactComponent };